import { createContext } from "react";

export const AuthContext = createContext({
    isLoggedIn: false,
    userId: null,
    role: 'viewer',
    token: null,
    username: null,
    name: null,
    image: null,
    email: null,
    phone: null,
    login: () => {},
    logout: () => {},
    updateAuth: () => {}
});